import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-accessibility-panel',
  templateUrl: './accessibility-panel.component.html',
  styleUrls: ['./accessibility-panel.component.scss']
})
export class AccessibilityPanelComponent implements OnInit {

  public isShown = false;

  // Data-bound properties
  public fontSize: 'normal' | 'larger' | 'largest' = 'normal';
  public fontWeight: 'normal' | 'bold' = 'normal';
  public colourScheme: 'default' | 'high-contrast' | 'dark-mode' = 'default';
  public lineSpacing: 'normal' | 'increased' = 'normal';
  public zoom: 'normal' | 'large' | 'xlarge' = 'normal';

  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
    this.applyAccessibilitySettings();
  }

  // Apply the classes dynamically to <body> or <html>
  applyAccessibilitySettings(): void {
    const body = document.body;

    // Clear previous classes
    this.renderer.removeClass(body, 'font-size-normal');
    this.renderer.removeClass(body, 'font-size-larger');
    this.renderer.removeClass(body, 'font-size-largest');

    this.renderer.removeClass(body, 'font-weight-normal');
    this.renderer.removeClass(body, 'font-weight-bold');

    this.renderer.removeClass(body, 'colour-scheme-default');
    this.renderer.removeClass(body, 'colour-scheme-high-contrast');
    this.renderer.removeClass(body, 'colour-scheme-dark-mode');

    this.renderer.removeClass(body, 'line-spacing-normal');
    this.renderer.removeClass(body, 'line-spacing-increased');

    this.renderer.removeClass(body, 'zoom-normal');
    this.renderer.removeClass(body, 'zoom-large');
    this.renderer.removeClass(body, 'zoom-xlarge');

    // Add selected classes
    this.renderer.addClass(body, `font-size-${this.fontSize}`);
    this.renderer.addClass(body, `font-weight-${this.fontWeight}`);
    this.renderer.addClass(body, `colour-scheme-${this.colourScheme}`);
    this.renderer.addClass(body, `line-spacing-${this.lineSpacing}`);
    this.renderer.addClass(body, `zoom-${this.zoom}`);
  }

  // Watch for changes and update classes
  setFontSize(size: 'normal' | 'larger' | 'largest'): void {
    this.fontSize = size;
    this.applyAccessibilitySettings();
  }

  setZoom(zoom: 'normal' | 'large' | 'xlarge'): void {
    this.zoom = zoom;
    this.applyAccessibilitySettings();
  }

  setFontWeight(weight: 'normal' | 'bold'): void {
    this.fontWeight = weight;
    this.applyAccessibilitySettings();

    if (weight == "normal") {
      (window as any).ToggleBoldFont(0);
    } else {
      (window as any).ToggleBoldFont(1);
    }
  }

  setColourScheme(scheme: 'default' | 'high-contrast' | 'dark-mode'): void {
    this.colourScheme = scheme;
    this.applyAccessibilitySettings();
  }

  setLineSpacing(spacing: 'normal' | 'increased'): void {
    this.lineSpacing = spacing;
    this.applyAccessibilitySettings();
  }
}
